import Weapon from './Weapon';

export default class Unit {
  operativeType;
  type; // Operative or Leader
  stats = {};
  abilities = [];
  uniqueActions = [];
  weapons = [];
  weaponsList = {};
  keywords = { primary: null, secondary: []};
  rules = {};


  constructor(xmlData) {
    this.type = xmlData.children[0].attributes.name;
    this.buildUnit(xmlData);
  }

  get isLeader() {
    return this.type === 'Leader' ? true : false;
  }

  buildUnit(data) {
    data.children.map((data) => {
      if (data.name === 'selections') {
        return this.buildWeapons(data);
      }
      if (data.name === 'profiles') {
        return this.buildProfile(data);
      }
    });

    this.buildKeywords(data.getElementsByTagName('category'));

    this.buildRules(data.getElementsByTagName('rule'));
  }

  buildProfile(data) {
    data.children.map((profile) => {
      if (profile.attributes.typeName === 'Operative') {
        this.operativeType = profile.attributes.name;
        profile.getElementsByTagName('characteristic').map((attr) => {
          return this.stats[attr.attributes.name] = attr.value;
        });
      }

      if (profile.attributes.typeName === 'Abilities') {
        this.abilities.push({
          name: profile.attributes.name,
          description: profile.getElementsByTagName('characteristic')[0].value
        });
      }

      if (profile.attributes.typeName === 'Unique Actions') {
        this.uniqueActions.push({
          name: profile.attributes.name,
          description: profile.getElementsByTagName('characteristic')[0].value
        });
      }
      return false;
    });
  }

  buildWeapons(data) {
    data.getElementsByTagName('selection').map((selection) => {
      const cost = selection.getElementsByTagName('cost');
      selection.getElementsByTagName('profile').map((profile) => {
        const weapon = new Weapon(profile, cost);
        this.weaponsList[weapon.name] = weapon;
      });
    });

    this.weapons = Object.keys(this.weaponsList).map((weapon) => (this.weaponsList[weapon]));

    this.uniqueActions.push(...this.weapons.filter((weapon) => weapon.type === 'unique_action'));

    this.abilities.push(...this.weapons.filter((weapon) => weapon.type === 'ability'));

    this.abilities.push(...this.weapons.filter((weapon) => weapon.type === 'equipment'));
  }

  buildKeywords(data) {
    data.map((category) => {
      if (category.attributes.primary === "true") {
        this.type = category.attributes.name;
      }

      if (category.attributes.primary === 'true') {
        this.keywords.primary = category.attributes.name;
      } else {
        this.keywords.secondary.push(category.attributes.name);
      }
    });
  }

  buildRules(rules) {
    rules.map((rule) =>
      (this.rules[rule.attributes.name] = {
        name: rule.attributes.name,
        description: rule.getElementsByTagName('description')[0].value
      })
    );
  }
}